import React, { createContext, useState } from 'react'

export interface MachineMeta {
  id: number | string
  name?: string
  [k: string]: any
}

interface MachineContextValue {
  activatedMachine: MachineMeta | null
  setActivatedMachine: (m: MachineMeta | null) => void
}

const defaultValue: MachineContextValue = {
  activatedMachine: null,
  setActivatedMachine: () => {},
}

export const MachineContext = createContext<MachineContextValue>(defaultValue)

interface Props {
  children: React.ReactNode
}

const MachineProvider = ({ children }: Props) => {
  const [activatedMachine, setActivatedMachine] = useState<MachineMeta | null>(null)

  return (
    <MachineContext.Provider value={{ activatedMachine, setActivatedMachine }}>
      {children}
    </MachineContext.Provider>
  )
}

export default MachineProvider
